"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cookies;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _CookiesWarning = _interopRequireDefault(require("./CookiesWarning"));
var _CookiesDetailDialog = _interopRequireDefault(require("./CookiesDetailDialog"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Cookies(props) {
  const {
    globalActions,
    t,
    cookieName
  } = props;
  const [cookiesDetailOpen, setcookiesDetailOpen] = (0, _react.useState)(false);
  const [openSnackBar, setOpenSnackBar] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const agreed = localStorage.getItem(cookieName);
    if (!agreed) {
      setOpenSnackBar(true);
    }
  }, [cookieName]);
  const agreeToCookies = () => {
    localStorage.setItem(cookieName, 'true');
    globalActions.setCookiesAccepted(true);
    setOpenSnackBar(false);
    setcookiesDetailOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement(_CookiesWarning.default, {
    openSnackBar: openSnackBar,
    agreeToCookies: agreeToCookies,
    t: t,
    setcookiesDetailOpen: setcookiesDetailOpen
  }), cookiesDetailOpen && /*#__PURE__*/_react.default.createElement(_CookiesDetailDialog.default, {
    t: t,
    open: cookiesDetailOpen,
    setOpen: setcookiesDetailOpen,
    agreeToCookies: agreeToCookies
  }));
}